// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__IBVuz","title":"FrontImage_title__2B36y"};